module.exports = __webpack_public_path__ + "static/media/press-tc-disrupt@2x.936b6ecf.jpg";